import codexData from "../../data/codex.json";

const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL ?? "").replace(/\/+$/, "");

const characterImages = new Map(
  codexData
    .filter(
      (entry) =>
        entry.is_published === true &&
        (entry.category === "Unhuan" || entry.category === "Pehuan"),
    )
    .map((entry) => [
      entry.title,
      entry.image
        ? entry.image.startsWith("/")
          ? entry.image
          : `/${entry.image}`
        : null,
    ]),
);

export function getCharacterBackdrop(character) {
  return characterImages.get(character) ?? null;
}

export function normalizePublicReviews(payload) {
  if (!payload?.success || !Array.isArray(payload.reviews)) return [];

  return payload.reviews
    .filter(
      (review) =>
        review &&
        typeof review.name === "string" &&
        review.name.trim() &&
        typeof review.body === "string" &&
        review.body.trim() &&
        typeof review.favoriteCharacter === "string" &&
        review.favoriteCharacter.trim(),
    )
    .map((review) => ({
      name: review.name.trim(),
      body: review.body.trim(),
      favoriteCharacter: review.favoriteCharacter.trim(),
      backdrop: getCharacterBackdrop(review.favoriteCharacter.trim()),
    }));
}

export async function fetchPublicReviews(signal) {
  const response = await fetch(`${apiBaseUrl}/api/public-reviews`, { signal });
  if (!response.ok) throw new Error("Reader reviews are temporarily unavailable.");
  return normalizePublicReviews(await response.json());
}
